import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useQuery from '../../../custom-hooks/useQuery';
import { SubmitApprovalViaMail, UpdateAttendanceFto } from '../../../services/attendance-change';
import { Container, Typography, Box, Paper } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material'; // Import from @mui/icons-material
import Approveimg from '../../../assets/images/Approvd.png' 
import Deniedimg from '../../../assets/images/Denied.png' 
 

export const CancellationThankyou = () => {
  const [message, setMessage] = useState('');
  const [success,setsucess] = useState(false);
const { ftoId } = useParams();
const query = useQuery();

const startDate = query.get("StartDate");
const voidReason = query.get("voidReason");
const userId = query.get("userId");
const isApprove = query.get("Approve") === "true";

const SubmitApproval = async () => {

  const data = {
    ftoId: Number(ftoId),
    startDate: startDate,
    voidReason: voidReason,
    userId: Number(userId),
    modifiedBy: Number(userId),
    isManagerApproval: isApprove,
    isManagerMAil: false
  };

  try {
    const response = await UpdateAttendanceFto(data);

    if (response.status === 200) {
      setMessage(isApprove ? "FTO Approved successfully" : "FTO Denied successfully");
      setsucess(true);
    }
  } catch {
    setMessage("An error occurred while submitting FTO");
    setsucess(false);
  }
};

  
useEffect(() => {
  if (ftoId && userId) {
    if (isApprove) {
      SubmitApproval(); // only approve calls API
    
    } else {
      setsucess(true); // directly show denied image
      setMessage("FTO Denied successfully");
    }
  }
}, []);
  
  return (
    <>
     {isApprove ? (
  success && <img src={Approveimg} alt="approved" height="100%" width="100%" />
) : (
  <img src={Deniedimg} alt="denied" height="100%" width="100%" />
)}
    </>
  );
}
